var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 11.6703V14.7437C1.33331 15.2095 1.50891 15.6562 1.82147 15.9856C2.13403 16.315 2.55795 16.5 2.99998 16.5H13C13.442 16.5 13.8659 16.315 14.1785 15.9856C14.4911 15.6562 14.6666 15.2095 14.6666 14.7437V11.6703M8.0006 11.4521L8.0006 1.5M8.0006 1.5L4.19108 5.30265M8.0006 1.5L11.8101 5.30265",
    stroke: "#4F4D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-Icon.b59787943acbca5e91bf62e617f63e1e.svg";
export { ForwardRef as ReactComponent };